import api from "../../../axiosConfig";

export const fetchCiudades = async (departamentoId) => {
  try {
    const response = await api.get(
      `/ciudades?departamento_id=${departamentoId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener ciudades:", error);
  }
};

export const fetchDepartamentos = async () => {
  try {
    const response = await api.get(`/departamentos`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener departamentos:", error);
  }
};
